import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import SpinnerIcon from "./Spinner.svg";

export const SPINNER_SIZES = {
  SMALL: 24,
  MEDIUM: 32,
  LARGE: 64
};

export const SPINNER_COLOR = {
  BLUE: "var(--kf-color-primary-500)",
  GRAY: "var(--gray-500)"
};

export function Spinner(props) {
  const { className, size, spinnerDelay, color = SPINNER_COLOR.BLUE } = props;
  const [showSpinner, setShowSpin] = useState(false);

  useEffect(
    function delaySpinnerRendering() {
      const spinTimeOut = setTimeout(() => {
        setShowSpin(true);
        clearTimeout(spinTimeOut);
      }, spinnerDelay);

      return () => clearTimeout(spinTimeOut);
    },
    [spinnerDelay]
  );

  if (!showSpinner) return null;

  return (
    <SpinnerIcon
      className={className}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        "--kf-spinner-color": color
      }}
    />
  );
}

Spinner.propTypes = {
  /** To define className */
  className: PropTypes.string,
  /**
   * size property indicates how much size loader need to render
   */
  size: PropTypes.oneOf(Object.values(SPINNER_SIZES)),
  /**
   * spinnerDelay indicates after how much delay loader need to rotate
   */
  spinnerDelay: PropTypes.number,
  /**
   * color indicates color of the spinner
   */
  color: PropTypes.oneOf(Object.values(SPINNER_COLOR))
};
